<template>
  <div class="calculator">
    <div class="calculatorbg">
      <appHeader activeIndex="calculator" ></appHeader>
      <div class="calculatorContent">
        <!-- 介绍 -->
        <div class="calculatorInfo">
          <div class="calculatorInfo1">
            <img class="calculatorInfo1Img1" src="../../assets/img/Product/calculator.png"  alt />
            <br><br><br><br><br>
            <!-- <img class="calculatorInfo1Img2"  src="../../assets/img/products/calculator/calculatorQRcode.png" alt /> -->
            <!-- <div>扫描二维码下载</div>      -->
          </div>
          <div class="calculatorInfo2">
            <div class="productTitle">
              全智能计算器
            </div>
            <br>
            超级全能的高级计算器，你值得拥有！
            <br><br>
             <el-divider></el-divider>
             <h4>这是一款功能非常多的计算器APP，它不仅可以计算，还能单位转换、汇率、记账等等，且看如下分析：</h4>
             <p>【科学计算 学生必备】这款计算器，不仅支持标准计算，还支持科学计算，体重计算，各种难搞的计算它都能实现，是学生和工作生活必备超能助手！</p>
             <p>【单位转换 功能齐全】一键转换所有单位，支持的单位转换包括：长度、面积、体积、重量、功、功率、压强、存储，选择对应的功能即可转换！</p>
             <p>【汇率计算 实时更新】需要使用汇率计算功能的朋友，无需担心计算不准确，我们的汇率计算支持实时更新，更好的保证了计算的准确率！</p>
             <p>【收支记账 一目了然】记账功能分类清晰，收入和支出统计明确，还有谁不需要一款收支记账的APP？及时记录每日收支情况，让你对自己的腰包更加了解，不再超支预算！</p>
             <p>全智能计算器，学生党和社畜必备生活工作良友！</p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容 -->
        <el-divider></el-divider>
        <div class="calculatorCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="calculatorWrap">
            <div class="calculatorMainImg" :style="{ left: nowLeft + '%' }">
              <img class="calculatorCarouselImg"   src="../../assets/img/products/calculator/carousel.png" alt />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +15
      },

      right() {
        if(this.nowLeft <= -45){
          return;
        }
        this.nowLeft = this.nowLeft -15
      }
  }
};
</script>
<style>
@import "../../assets/css/products/calculator.css";
</style>
